import { RefreshCw, Check, Cloud } from "lucide-react";
import { useOffline } from "@/context/OfflineContext";
import { Button } from "@/components/ui/button";

const SyncIndicator = () => {
  const { isOnline, isSyncing, pendingSync, syncWithServer } = useOffline();

  if (!isOnline && pendingSync === 0) return null;

  return (
    <div className={`sync-indicator ${isSyncing ? "syncing" : ""}`} data-testid="sync-indicator">
      {isSyncing ? (
        <RefreshCw className="w-6 h-6 text-sky-600 animate-spin" />
      ) : pendingSync > 0 ? (
        <Button
          variant="ghost"
          size="icon"
          onClick={syncWithServer}
          className="relative"
          data-testid="sync-button"
        >
          <Cloud className="w-6 h-6 text-orange-500" />
          <span className="absolute -top-1 -right-1 bg-orange-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
            {pendingSync}
          </span>
        </Button>
      ) : (
        <Check className="w-6 h-6 text-green-500" />
      )}
    </div>
  );
};

export default SyncIndicator;
